import { IDS } from '../requirements-assessment-action-id.constants';
import { GridController, gridTpl } from '../../../../common/grid/grid.controller';
import * as Actions from './evidence-group-details.actions';

class EvidenceGroupDocumentsGridController extends GridController {
    constructor($ngRedux,
                $state,
                NavigationService,
                AuthService,
                FileActions,
                $filter,
                $mdDialog,
                $scope
    ) {
        super($ngRedux, $state, NavigationService, $filter, $mdDialog);
        this.$scope = $scope;
        this.AuthService = AuthService;
        this.Actions = Actions;
        this.FileActions = FileActions;
    }

    $onInit() {
        this.module = 'accreditation';
        this.statePath = IDS.rcoEvidenceGroupDocumentsGrid;
        this.autoload = false;
        // this.filterControls = false;
        this.exportComponent = false;
        this.filterExpandButtonVisible = false
        this.confirmDialogOnRemove = true;
        // this.confirmDialogOnRemoveText = '';
        // this.filterComponent = false;
        // this.header = false;
        this.icon = false;

        const user = this.AuthService.getUser();
        const isAdmin = user.type === 'Administrator';
        this.basicTypeName = user.basicTypeName;
        this.columns = [
            {title: '#',                                                    mapper: null},
            {title: 'Number',                                               mapper: 'doc_num'},
            {title: 'Type',                                                 mapper: 'doc_type_name'},
            {title: this.$filter('translate')('COMMON.FIELD.NAME'),         mapper: 'name'},
            {title: this.$filter('translate')('COMMON.FIELD.VERSION'),      mapper: 'doc_version'},
            {title: this.$filter('translate')('COMMON.FIELD.UPLOADED_BY'),  mapper: 'uploaded_by'},
            {title: this.$filter('translate')('COMMON.FIELD.UPLOADED_AT'),  mapper: 'uploaded_at'},
            {title: this.$filter('translate')('COMMON.FIELD.STATUS'),       mapper: 'status'},
            {title: this.$filter('translate')('COMMON.BUTTON.DOWNLOAD'),    mapper: 'download'},
            // {title: 'Approved', mapper: 'checkbox', identifier:this.identifier, statePath: `${this.statePath}.approved`, style:{width:'35px'}},
            // {title: 'Returned', mapper: 'checkbox', identifier:this.identifier, statePath: `${this.statePath}.returned`, style:{width:'35px'}}
        ];

        this.unsubscribe = this.$ngRedux.connect(this.mapState().bind(this), {...this.Actions, ...this.FileActions})(this);
        this.unsubscribeCustom = this.$ngRedux.connect(state => {
            const {rcoRequirementsAssessment, selectedRequirement, } = state.accreditation;
            return {
                selectedSiteLocation: rcoRequirementsAssessment?.selectedSiteLocation,
                auditIsScheduled:     selectedRequirement?.requirement_page_status !== 'mis',
                assessmentEnabled:    isAdmin || !!rcoRequirementsAssessment.auditors?.find(item => item.assignee_uuid === user.uuid),
            }
        }, {})(this);
        this.dataAction = this.fetchRequirementEvidenceGroupDocumentsGrid;
        this.buttons.push(
            {
                name: 'update',
                class: 'btnGridAction',
                label: this.$filter('translate')('COMMON.BUTTON.UPDATE'),
                callback: this.onUploadButton,
                filter: item =>
                    !this.buttonsDisabled
            },
            {
                name: 'approve',
                class: 'btnGridModify',
                label: this.$filter('translate')('COMMON.BUTTON.APPROVE'),
                callback: this.onApproveButton,
                filter: item =>
                    !this.buttonsDisabled
                    && this.auditIsScheduled
                    && item.status_code !== 'app'
                    && this.assessmentEnabled
                    && this.identifier === IDS.rcoRequirementsAssessment
            },
            {
                name: 'reject',
                class: 'btnGridRemove',
                label: this.$filter('translate')('COMMON.BUTTON.REJECT'),
                callback: this.onRejectButton,
                filter: item =>
                    !this.buttonsDisabled
                    && this.auditIsScheduled
                    && (item.status_code !== 'nap' || item.doc_revision_task_status_code === 'cpl')
                    && this.assessmentEnabled
                    && this.identifier === IDS.rcoRequirementsAssessment
            },
            {
                name: 'remove',
                class: 'btnGrid',
                label: this.$filter('translate')('COMMON.BUTTON.REMOVE'),
                callback: this.onRemoveButton,
                filter: item =>
                    !this.buttonsDisabled
                    && isAdmin
            },
        );
        this.init();
    }

    $onDestroy() {
        if(this.unsubscribe)
            this.unsubscribe();
        this.destroy();
    }
}

EvidenceGroupDocumentsGridController.$inject = ['$ngRedux', '$state', 'NavigationService', 'AuthService', 'FileActions','$filter', '$mdDialog', '$scope'];

export const evidenceGroupDocumentsGrid = {
    bindings: {
        onUploadButton: '&',
        onApproveButton: '&',
        onRejectButton: '&',
        onRemoveButton: '&',
        onSelect: '&',
        identifier: '@',
        buttonsDisabled: '<',
        title: '<'
    },
    controller: EvidenceGroupDocumentsGridController,
    ...gridTpl
}
